<div class="w-full max-w-5xl p-8">
    @if (!showMyIncidents) {
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
            <button mat-button (click)="goToAssistsOverview()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            </button>
            <h2 class="!mt-0 content-center">{{ 'label_incident_report' | translatePlural }}</h2>
        </div>
        <span class="separator-line block"></span>
        <br />
        <div class="grid grid-cols-1 gap-8 w-full my-4">
            <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
                <div
                    (click)="redirectToJiraForm()"
                    class="atvik-container relative flex flex-col flex-auto p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden"
                >
                    <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                        <mat-icon
                            class="icon-size-24 opacity-25 text-blue-500"
                            [svgIcon]="'heroicons_outline:exclamation-triangle'"
                        ></mat-icon>
                    </div>
                    <div class="flex items-center">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate mb-[5px]">
                                {{ 'label_report_incident' | translate }}
                            </div>
                            <div class="text-secondary font-medium text-md">
                                {{ 'text_report_incident' | translate }}
                            </div>
                        </div>
                    </div>
                    <span class="text-md c-link mt-1 text-primary">{{ 'label_register_incident' | translate }}</span>
                </div>
            </div>
        </div>

        <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
            <div
                (click)="goToMyIncidents()"
                class="atvik-container relative flex flex-col flex-auto p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden"
            >
                <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                    <mat-icon class="icon-size-24 opacity-25 text-orange-500" [svgIcon]="'heroicons_outline:list-bullet'"></mat-icon>
                </div>
                <div class="flex items-center">
                    <div class="flex flex-col">
                        <div class="text-lg font-medium tracking-tight leading-6 truncate mb-[5px]">
                            {{ 'label_my_incident_reports' | translate }}
                        </div>
                        <div class="text-secondary font-medium text-md">
                            {{ 'text_my_incident_reports' | translate }}
                        </div>
                    </div>
                </div>
                <span class="text-md c-link mt-1 text-primary">{{ 'label_my_incidents' | translate }}</span>
            </div>
        </div>
    }

    @if (showMyIncidents) {
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
            <button mat-button (click)="goToIncidentOverview()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            </button>
            <h2 class="!mt-0 content-center">{{ 'label_my_incident_reports' | translatePlural }}</h2>
        </div>
        <span class="separator-line block"></span>
        <br />
        <div>
            <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData" class="w-[100%]">
                <ng-container matColumnDef="key">
                    <th mat-sort-header="key" mat-header-cell *matHeaderCellDef>
                        {{ 'label_audkenni' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <a class="c-link" target="_blank" [matTooltip]="'label_open_request' | translate" href="{{ element.url }}">{{
                            element.key
                        }}</a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="title">
                    <th mat-sort-header="title" mat-header-cell *matHeaderCellDef>
                        {{ 'label_title' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <a class="c-link" target="_blank" [matTooltip]="'label_open_request' | translate" href="{{ element.url }}">{{
                            element.title
                        }}</a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="created">
                    <th mat-sort-header="created" mat-header-cell *matHeaderCellDef>
                        {{ 'label_date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span [matTooltip]="'label_registered_at' | translate">{{ formatDate(element.created) }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>
                        {{ 'label_status' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span
                            class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                            [ngClass]="{
                                'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': element.status === 'Móttekið',
                                'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': element.status === 'Hætt við',
                                'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50':
                                    element.status !== 'Móttekið' &&
                                    element.status !== 'Hætt við' &&
                                    element.status !== 'Lokið' &&
                                    element.status !== 'Leyst',
                                'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                    element.status === 'Lokið' || element.status === 'Leyst',
                            }"
                        >
                            <span class="leading-relaxed whitespace-nowrap">{{ element.status }}</span>
                        </span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="orgRequestsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: orgRequestsColumns"></tr>
                <tr class="mat-row" [ngClass]="{ 'h-0': isLoading }" *matNoDataRow>
                    @if (!isLoading && initialFetchComplete) {
                        <div class="flex items-center justify-between">
                            <span>
                                <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">
                                    {{ 'info_requests_found_count' | translate: { count: 0 } }}
                                </div>
                            </span>
                        </div>
                    }
                </tr>
            </table>
        </div>
        @if (isLoading) {
            <div class="flex justify-center items-center gap-2 pt-4 pb-4 bg-white">
                <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'"> </mat-progress-spinner>
                Sæki atvik
            </div>
        }
        @if (!isLastPage) {
            <div #sentinel class="h-1"></div>
        }
    }
</div>
